import CheckBoxIcon from './component'

export default CheckBoxIcon
